import { Permission } from "./Permission.enum";

export const permissionMap: Record<Permission, string> = {
  [Permission.CreateTag]: "create:tag",
  [Permission.UpdateTag]: "update:tag",
  [Permission.DeleteTag]: "delete:tag",
  [Permission.ReadAllUsersConversations]: "read:all-users-conversations",
  [Permission.ReadFeatureFlag]: "read:feature-flag",
  [Permission.UpdateUserFeatureFlag]: "update:user-feature-flag",
  [Permission.UpdateUserRoles]: "update:user-roles",
  [Permission.ReadRoles]: "read:roles",
  [Permission.CreateToneOfVoice]: "create:tone-of-voice",
  [Permission.UpdateToneOfVoice]: "update:tone-of-voice",
  [Permission.DeleteToneOfVoice]: "delete:tone-of-voice",
  [Permission.RebuildProjection]: "rebuild:projection", // INFO: Ikke en FE ting pt.
  [Permission.CreateTenantColors]: "create:tenant-colors", // INFO: Ikke en FE ting pt.
  [Permission.UpdateTenantColors]: "update:tenant-colors", // INFO: Ikke en FE ting pt.
  [Permission.CreateFeatureGroups]: "create:feature-groups",
  [Permission.UpdateFeatureGroups]: "update:feature-groups",
  [Permission.ReadGroups]: "read:groups",
  [Permission.CreateSearchShare]: "create:search-share",
  [Permission.CreateWorkspaceOrgShared]: "create:workspace-org-shared",
  [Permission.DeleteWorkspaceDocumentsOwn]: "delete:workspace-documents-own",
  [Permission.UpdateDashboardLayout]: "update:dashboard-layout",
  [Permission.UpdatePromptsApproval]: "update:prompts-approval",
  [Permission.ReadInsights]: "read:insights",
  [Permission.UpdateWorkspaceSharingOrgShared]:
    "update:workspace-sharing-org-shared",
  [Permission.CreateNotification]: "create:notification", // INFO: Ikke en FE ting pt.
  [Permission.UpdateTenantMetadata]: "update:tenant-metadata",
  [Permission.ReadOrganizationInvitation]: "read:organization-invitation",
  [Permission.ReadOrganizationConnection]: "read:organization-connection",
  [Permission.CreateOrganizationInvitation]: "create:organization-invitation",
  [Permission.DeleteOrganizationInvitation]: "delete:organization-invitation",
  [Permission.UpdateSynonymGroup]: "update:synonym-group",
  [Permission.CreateHubspotTicket]: "create:hubspot-ticket",
  [Permission.DeleteUser]: "delete:user",
  [Permission.ManageOrphanedWorkspaces]: "manage:orphaned-workspaces",
  [Permission.ManageWidgetTemplates]: "manage:widget-templates",
  [Permission.CreateConsolidationFeedback]: "create:consolidation-feedback",
  [Permission.ManagePiiSettings]: "manage:pii-settings",
  [Permission.DeleteAnyConversation]: "delete:any-conversation",
  [Permission.ManageConsolidationPriority]: "manage:consolidation-priority",
};
